import script from "./DynamicTopMatter.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicTopMatter.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicTopMatter.vue?vue&type=style&index=0&id=f9632424&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9632424"]])

export default __exports__